import React from 'react';
import cx from 'classnames';
import { COPY_STRINGS } from '../../../constants/translatedCopy';
import { logSessionInfo } from '../../../services/logger';

export default class RANItems extends React.Component {
  constructor(props) {
    super(props);
    this.imageRef = React.createRef();
    this.mutationObserver = null;
    this.checkImageVisibility = this.checkImageVisibility.bind(this);
  }

  get rewrittenImageSrc() {
    const { image } = this.props;
    if (image && process.env.ASSET_ROOT) {
      return image.replace("s3.amazonaws.com/amira-assets", process.env.ASSET_ROOT);
    }
    return image;
  }

  componentDidMount() {
    try {
      if (this.imageRef.current) {
        // this attempts to force the image to be visible by setting the style properties
        this.imageRef.current.style?.setProperty?.('visibility', 'visible', 'important');
        this.imageRef.current.style?.setProperty?.('opacity', '1', 'important');
        this.imageRef.current.style?.setProperty?.('display', 'block', 'important');
        
        // Set up MutationObserver to watch for changes
        this.mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && 
                (mutation.attributeName === 'style' || 
                mutation.attributeName === 'class' ||
                mutation.attributeName === 'hidden')) {
              this.checkImageVisibility('mutation_detected', mutation);
            }
          });
        });

        // Start observing the image element
        this.mutationObserver.observe(this.imageRef.current, {
          attributes: true,
          attributeFilter: ['style', 'class', 'hidden']
        });
      }
    } catch (error) {
      console.error('Error checking image visibility', error);
      logSessionInfo('ran_image_visibility_init_error', { error: error.message });
    }
  }

  checkImageVisibility(trigger) {
    try {
      if (!this.imageRef?.current) return;
      
      const img = this.imageRef.current;
      const computedStyle = window.getComputedStyle(img);
      const isHidden = 
        computedStyle.visibility === 'hidden' ||
        computedStyle.opacity === '0' ||
        img.offsetWidth === 0 ||
        img.offsetHeight === 0;
      const safeUrl = (url) => typeof url === 'string' && url.startsWith('http') ? url : '[non-url]';
      const logData = {
        trigger: trigger,
        imageSrc: safeUrl(this.rewrittenImageSrc),
        imageSrcRaw: safeUrl(this.props.image),
        display: computedStyle.display,
        visibility: computedStyle.visibility,
        opacity: computedStyle.opacity,
        offsetWidth: img.offsetWidth,
        offsetHeight: img.offsetHeight,
        className: img.className,
        inlineStyle: img.getAttribute('style'),
        isInstruction: this.props.isInstruction
      };
      console.info('RANItem image visibility info:', logData);
      if (isHidden) {
        logSessionInfo('ran_image_hidden', logData);
        console.error('RANItem image hidden:', logData);
      }
    } catch (error) {
      console.error('Error checking image visibility', error);
      logSessionInfo('ran_image_visibility_check_error', { error: error.message });
    }
  }

  componentWillUnmount() {
    if (this.mutationObserver && typeof this.mutationObserver.disconnect === 'function') {
      this.mutationObserver.disconnect();
      this.mutationObserver = null;
    }
  }

  //TODO: refactor so that this isn't a RAN component but an "Image" component?
  render() {
    let ranStyles = cx({
      'ranImage': true,
      'outlined': true,
      'example': this.props.isInstruction,
    });

    return (
      <div className="ranItems">
        {this.props.isInstruction && <div className="exampleIndicator">{COPY_STRINGS.example}:</div>}
        <img
          ref={this.imageRef}
          className={ranStyles}
          src={this.rewrittenImageSrc}
          alt=""
        />
      </div>
    );
  }
}
